<template>
    <div class="
      hidden size-full min-h-dvh

      lg:flex lg:flex-1 lg:flex-col
    ">
        <div class="size-full max-h-[calc(100dvh-113px)] overflow-y-auto bg-white">
            <transition name="cz3__fade-fast-slide" mode="out-in">
                <div class="flex size-full overflow-y-auto" v-if="currentStep !== STEP_LOADING">
                    <customizer-step-controls />

                    <transition name="cz3__fade" mode="out-in">
                        <component :is="stepComponents[currentStep]" class="lg:pt-[64px]" />
                    </transition>
                </div>
            </transition>

        </div>
        <price-and-review />
    </div>

    <!-- mobile -->
    <div class="
      flex size-full flex-col

      lg:hidden
    ">
        <button
            class="fixed left-[24px] top-[20px] z-20 flex size-[36px] items-center justify-center rounded-full bg-black/15"
            @click="executeStartOver"
        >
            <restart-icon class="text-white close-icon size-[20px]" />
        </button>
        <button
            class="fixed right-[24px] top-[24px] z-20 flex size-[36px] items-center justify-center rounded-full bg-black/15"
            @click="handleQuit"
        >
            <close-icon class="text-white close-icon size-[12px]" />
        </button>
        <div class="
          flex min-h-0 flex-auto flex-col bg-white

          sm:overflow-y-auto
        ">
            <transition name="cz3__fade-fast-slide" mode="out-in">
                <div
                    v-if="currentStep !== STEP_LOADING"
                    class="relative flex min-h-0 flex-auto flex-col bg-white"
                >
                    <customizer-step-controls v-if="currentStep !== STEP_REVIEW"
                        class="sticky top-0 flex-none"
                    />

                    <component :is="stepComponents[currentStep]" class="min-h-0 flex-auto"
                        :class="{
                            'px-[24px]': currentStep !== STEP_ICONS,
                        }"
                    />
                </div>
            </transition>
        </div>
        <back-and-add-to-cart-mobile v-if="currentStep === STEP_REVIEW" />
        <price-and-review v-else />
    </div>
</template>

<script>
    import allStores from '../stores/all';

    import {
        STEP_WALLET,
        STEP_BULK_ORDER,
        STEP_ICONS,
        STEP_TEXT,
        STEP_MONOGRAM,
        STEP_REVIEW,
        STEP_LOADING,
    } from '../constants';

    import BodyStep from './steps/BodyStep.vue';
    import BulkOrderingStep from './steps/BulkOrderingStep.vue';
    import IconsStep from './steps/IconsStep.vue';
    import TextStep from './steps/TextStep.vue';
    import MonogramStep from './steps/MonogramStep.vue';
    import PriceInfo from './PriceInfo.vue';
    import PriceAndReview from './PriceAndReview.vue';
    import ReviewStep from './steps/ReviewStep.vue';
    import CustomizerStepControls from './CustomizerStepControls.vue';
    import CloseIcon from './icons/CloseIcon.vue';
    import BackAndAddToCartMobile from './BackAndAddToCartMobile.vue';
    import RestartIcon from './icons/RestartIcon.vue';

    export default {
        mixins: [allStores],

        data() {
            return {
                stepComponents: {
                    [STEP_WALLET]: 'BodyStep',
                    [STEP_ICONS]: 'IconsStep',
                    [STEP_TEXT]: 'TextStep',
                    [STEP_MONOGRAM]: 'MonogramStep',
                    [STEP_BULK_ORDER]: 'BulkOrderingStep',
                    [STEP_REVIEW]: 'ReviewStep',
                },
                STEP_REVIEW,
                STEP_LOADING,
                STEP_ICONS,
            };
        },

        components: {
            BodyStep,
            BulkOrderingStep,
            IconsStep,
            TextStep,
            MonogramStep,
            PriceInfo,
            PriceAndReview,
            CustomizerStepControls,
            ReviewStep,
            CloseIcon,
            BackAndAddToCartMobile,
            RestartIcon,
        },

        computed: {
            currentStep() {
                return this.appStore.currentStep;
            },
        },

        methods: {
            handleQuit() {
                this.customizerStore.toggleQuitConfirmationModal();
            },

            executeStartOver() {
                this.customizerStore.toggleStartOverConfirmationModal();
            },
        },
    };
</script>
